import { AnyType, Avatar, Box, Text } from '@centra/centra-ui/dist'
import React from 'react'

export const AccountManagerOption = ({ data }: { data: AnyType }) => {
  return (
    <Box gap={8} alignItems={'center'}>
      <Avatar size={'sm'} imageUrl={data.avatar} lastName={data.lastName} firstName={data.firstName} />
      <Box column>
        <Box>
          <Text id={'taskLabel'} color={'basicBlack'} size={'primary'}>
            {data.label}
          </Text>
        </Box>
        <Box>
          <Text id={'taskLabel'} color={'basicGreyDark'} size={'caption'}>
            {data.email}
          </Text>
        </Box>
      </Box>
    </Box>
  )
}
